module.exports = __webpack_public_path__ + "8717a319251c58ff6e9bf7ea6ceae987.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/bg1.png
// module id = 826
// module chunks = 3